import { isGuestUser, setUser } from "../helperMethods";
import { logout } from "../../context/UserAuthentication";
import { IRefreshTokenPayload } from "../../models/forms.model";
import axiosNoInterceptor from "../../services/axiosNoInterceptor";
import { CUSTOMER_MICRO_SERVICE, utcTimeLambdaURL } from "../../constants";
import { isLoginAction } from "../../redux/slices/cartSlice";
import { unauthorizeLogout } from "../../context/UserAuthentication/actions";

function calculateCurrentUtcTime() {
    // Padding single digits with leading zero. Because our lambda function return date in specific format e.g: 2025-07-18 12:04:35
    const paddingWithZero = (number) => String(number).padStart(2, '0');
    let currentUTCDate = new Date();

    // here formatted the date in this format : Year-Month-Date Hours:Minutes:Seconds 
    let currentUTC_time =
    `${currentUTCDate.getUTCFullYear()}-${paddingWithZero(currentUTCDate.getUTCMonth() + 1)}-${paddingWithZero(currentUTCDate.getUTCDate())} ` +
    `${paddingWithZero(currentUTCDate.getUTCHours())}:${paddingWithZero(currentUTCDate.getUTCMinutes())}:${paddingWithZero(currentUTCDate.getUTCSeconds())}`;

    return { data : {time : currentUTC_time}}
}  

export const currentUtcTime = async () => {
    let response ;
    try{
        response = await axiosNoInterceptor.get(utcTimeLambdaURL)
        return response?.data?.time;
    }catch(error){
        response = calculateCurrentUtcTime();
        return response.data.time;
    }
}

const refreshAuthToken = async (data: IRefreshTokenPayload) => {
    const response = await axiosNoInterceptor.post(`${CUSTOMER_MICRO_SERVICE}/auth/refresh-token`, data, {
        headers: {
            'Authorization': "token",
            'token': "token"
        }
    })
    return response.data.data;
};

export const isTokenExpired = async (user) => {
    if (isGuestUser(user) || !user?.authentication_token) {
        return { shouldRefetchToken: false, shouldLogout: false };
    }
    const authExpiresAt = user.expires_at || null;
    const refreshExpiresAt = user.refresh_expires_at || null;
    const utcNow = await currentUtcTime();
    const currentDate = new Date(utcNow).getTime();
    const authTokenExpiry = new Date(authExpiresAt).getTime();
    const refreshTokenExpiry = new Date(refreshExpiresAt).getTime();
    const shouldLogout = authTokenExpiry <= currentDate && refreshTokenExpiry <= currentDate;
    const shouldRefetchToken = authTokenExpiry <= currentDate || refreshTokenExpiry <= currentDate || !authExpiresAt;
    return { shouldRefetchToken, shouldLogout };
}

export const refreshToken = async (dispatch: any, user) => {
    let response = null;
    try {
        response = await refreshAuthToken({
            refresh_token: user.refresh_token,
            auth_token: user.authentication_token,
        });
        setUser(response);
        dispatch(isLoginAction());
    }
    catch (error) {
        unauthorizeLogout(dispatch);
    }
    return response;
}